// pages/InspGreet.js
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';

export default function InspGreet() {
  const videos = [
    {
      url: 'https://youtu.be/TxSsf9mGa78',
      author: 'ירדנה אלון - מחמ"ד חיפה'
    },
    {
      url: 'https://youtu.be/bGMD13o4iAM',
      author: 'יעל בלום - מפקחת חמ"ד על יסודי'
    },
    {
      url: 'https://youtube.com/shorts/HvYBHlsrlaU',
      author: 'הרב מנחם קליין - מפמ"ר תושב"ע'
    },
    {
      url: 'https://youtube.com/shorts/2UfJB2PdXBM',
      author: 'הרב יוחאי רודיק - מפמ"ר מחשבת ישראל'
    }
  ];

  return (
    <div className="page-wrapper">
      <Breadcrumbs
        items={[
          { to: '/disciplines', label: 'תחומי דעת' },
          { label: 'דברי ברכה' },
        ]}
      />

      <div className="toolbar-center">
        <h2 className="text-2xl md:text-3xl font-bold text-secondary-900 dark:text-white">
          דברי ברכה לאתר הקודש במרכז
        </h2>
      </div>

      <p className="text-center mt-2 mb-6">
        <Link
          to="/disciplines"
          className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300"
        >
          חזרה לתחומי דעת
        </Link>
      </p>

      <div className="max-w-4xl mx-auto">
        {/* Videos section */}
        <section className="mb-8">
          <div className="space-y-6">
            {videos.map((video, idx) => (
              <div key={idx} className="bg-white dark:bg-secondary-800 rounded-2xl shadow-card overflow-hidden">
                <div className="p-4 md:p-5 border-b border-secondary-200 dark:border-secondary-700">
                  <p className="text-lg font-semibold text-secondary-900 dark:text-white text-center">
                    {video.author}
                  </p>
                </div>
                <div className="aspect-video bg-black">
                  <YoutubeEmbed videoId={extractYouTubeVideoId(video.url)} />
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Text section */}
        <section className="bg-white dark:bg-secondary-800 rounded-2xl p-6 md:p-8 shadow-card">
          <div className="space-y-4 text-secondary-700 dark:text-secondary-300 leading-relaxed">
            <p>
              לכבוד רבני בתי הספר והמלוות הרוחניות,
            </p>
            <p>
              מחוז חיפה
            </p>
            <p className="font-semibold">
              השלום והברכה!
            </p>
            <p className="text-center italic my-4">
              "אָז נִדְבְּרוּ יִרְאֵי ה' אִישׁ אֶת רֵעֵהוּ, וַיַּקְשֵׁב ה' וַיִּשְׁמָע..." (מלאכי ג', ט"ז)
            </p>
            <p>
              שמחתי והתרגשתי לשמוע על הפעילות הברוכה באתר "הקודש במרכז", המהווה בית ופלטפורמה לשיתוף, להפריה הדדית וללמידת עמיתים בין רבני בתי הספר והמלוות הרוחניות במחוז חיפה.
            </p>
            <p>
              עבודת הקודש החינוכית, מטבעה, נעשית לעיתים בצנעה, בתוך כותלי בית הספר וביוזמות אישיות של רב ותלמיד.
              אך ישנו ערך עצום לעמול על כתיבת היוזמות השונות, עיבודן ושיתופן – על מנת לפרוץ גבולות ולהשפיע במעגלים רחבים הרבה יותר.
            </p>
            <p>
              חז"ל לימדונו כי "קנאת סופרים תרבה חוכמה". אין הכוונה חלילה לקנאה של צרות עין, אלא לקנאה חיובית של רצון להתקדם, ללמוד מהצלחותיו של האחר, ולקבל השראה מיוזמות ברוכות. כאשר רב או מלווה רוחנית מעלים לאתר מערך שיעור מוצלח, דף מקורות מעניין, או תובנה חינוכית – הם מדליקים נר שממנו יכולים רבים אחרים להדליק את נרותיהם, מבלי שיחסר מהאור הראשון דבר.
            </p>
            <p>
              אני מבקש לחזק את ידי העוסקים במלאכה, את הנהגת המחוז ואת כל הרבנים והמלוות הרוחניות השותפים לעשייה. יהי רצון שהאתר יהיה מעיין המתגבר של תורה, יראת שמיים ויצירה חינוכית, ושנזכה לראות ברכה בעמלנו ולהגדיל תורה ולהאדירה.
            </p>
            <p className="font-semibold">
              המשיכו ליצור, לשתף ולהאיר!
            </p>
            <p>
              בברכה ובהערכה רבה,
            </p>

            <div className="pt-4 border-t border-secondary-200 dark:border-secondary-700 mt-6">
              <p className="font-medium text-secondary-900 dark:text-white">
                הרב עתניאל מנצור<br />
                <span className="text-secondary-500 dark:text-secondary-400">
                  מפקח ארצי על רבני בתי ספר בחמ"ד
                </span>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

// Utility function to extract YouTube video ID from various URL formats
function extractYouTubeVideoId(url) {
  if (!url) return null;
  
  // Patterns for different YouTube URL formats including Shorts
  const patterns = [
    /(?:youtube\.com\/embed\/|youtu\.be\/|youtube\.com\/watch\?v=)([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
    /youtube\.com\/shorts\/([^&\n?#\/]+)/,
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  return null;
}

// YouTube Embed Component
function YoutubeEmbed({ videoId }) {
  if (!videoId) return null;
  
  return (
    <div className="relative w-full h-full overflow-hidden">
      <iframe
        className="absolute inset-0 w-full h-full"
        src={`https://www.youtube.com/embed/${videoId}`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="סרטון YouTube"
        loading="lazy"
      />
    </div>
  );
}